import "./ewaybillResultTable.less";
import React, { useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import useWaybillResultTableColumns from "./useWaybillResultTableColumns";
import { observer } from "mobx-react-lite";
import { getAutoRowSpan } from "@/utils/table";
import MultiPlatformEwaybillResultStore from "./MultiPlatformEwaybillResultStore";
import { without } from "lodash";

interface EwaybillResultTableFormProps {
    printerName: string;

    store: MultiPlatformEwaybillResultStore;
}

const EwaybillResultTable: React.FC<EwaybillResultTableFormProps> = function (props) {
    const { printerName, store } = props;

    const [tableHeight, setTableHeight] = useState(430);
    const columns = useWaybillResultTableColumns(store);

    /** 部分用户会将发货结果的内容直接复制拖入Excel中，插入对应的换行符和制表符，展示以下的格式 */
    /** 列         列          列 */
    /** 订单编号    地址         运单号*/
    const handleCopy = useCallback((evt) => {
        const selection = document.getSelection();

        const proSelectionResult = [];

        const selectionSplit = selection.toString().split("\n");

        selectionSplit.forEach((str, index) => {
            if (!str) {
                return;
            }

            if (selectionSplit[index - 1] === "" && selectionSplit[index + 1] === "") {
                proSelectionResult.push("\r\n");

                proSelectionResult.push(str);

                proSelectionResult.push("\t");

                return;
            }

            proSelectionResult.push(str);

            proSelectionResult.push("\t");
        });

        evt.clipboardData.setData("text/plain", proSelectionResult.join(""));

        evt.preventDefault();
    }, []);

    useEffect(() => {
        const tableContainer = document.getElementById("ewaybill-result-table");

        if (tableContainer) {
            tableContainer.addEventListener("copy", handleCopy);

            return () => {
                tableContainer.removeEventListener("copy", handleCopy);
            };
        }
    }, []);

    const dataSource = printerName
        ? store.dataSource.filter((it) => {
              return it.printerName === printerName;
          })
        : store.dataSource;

    useEffect(() => {
        if (dataSource?.length > 5) {
            const height = Math.max(window.innerHeight - 520, 430);

            setTableHeight(height);
        }
    }, [dataSource]);

    return (
        <Table
            id="ewaybill-result-table"
            style={{ fontSize: 12 }}
            size="small"
            bordered
            columns={columns}
            rowKey="rowKey"
            className="ec-ewaybill-result-table-class"
            scroll={{
                y: tableHeight,
            }}
            rowSelection={{
                renderCell(value, record, index, originNode) {
                    return originNode;
                },
                onCell(record, index) {
                    return {
                        rowSpan: getAutoRowSpan(dataSource, record, index, "orderId"),
                    };
                },
                getCheckboxProps(record) {
                    return {
                        disabled: !record.ewaybill || !record.canSelected,
                    };
                },
                selectedRowKeys: store.selectedRowKeys,
                // 这里store里的selectedRowKeys存储的所有table的选中,所以这里要特殊处理
                onChange: (rowKeys: string[]) => {
                    const allRowKeys = dataSource.map((it) => it.rowKey);

                    const realSelected = without(store.selectedRowKeys, ...allRowKeys);

                    realSelected.push(...rowKeys);

                    store.onRowSelectionChange(realSelected);
                },
                selections: false,
            }}
            rowClassName="remove-selected-class"
            dataSource={dataSource}
            pagination={dataSource.length > 1000 ? { pageSize: 100, pageSizeOptions: ["100"] } : false}
        />
    );
};

export default observer(EwaybillResultTable);
